import React, { useEffect, useState } from 'react';
import {
  Box, Button, Input, Image, VStack, Heading, useToast, Text, Spinner, Alert, AlertIcon,
} from '@chakra-ui/react';
import axios from '../../api/AxiosInstance';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

const Activar2FA = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const [token, setToken] = useState('');
  const [activando, setActivando] = useState(false);
  const [yaActivado, setYaActivado] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (user?.id) {
      verificar2FAExistente();
    }
  }, [user]);

  const verificar2FAExistente = async () => {
    try {
      const res = await axios.get(`/Usuarios/${user.id}`);
      if (res.data[0]?.otpSecret) {
        setYaActivado(true);
      } else {
        generarQR();
      }
    } catch (err) {
      toast({
        title: 'Error al verificar 2FA',
        status: 'error',
        isClosable: true,
      });
    }
  };

  const generarQR = async () => {
    try {
      const { data } = await axios.get(`/2fa/setup/${user.id}`);
      setQrCode(data.qrCode);
      setSecret(data.secret);
    } catch (err) {
      toast({
        title: 'Error al generar código QR',
        status: 'error',
        isClosable: true,
      });
    }
  };

  const confirmarCodigo = async () => {
    if (!token.trim()) {
      return toast({
        title: 'Ingresa el código 2FA',
        status: 'warning',
        isClosable: true,
      });
    }

    setActivando(true);

    console.log(user.id)
    console.log(token)
    console.log(secret)
    try {
      await axios.post('/2fa/confirmar', {
        userId: user.id,
        token,
        secret,
      });

      toast({
        title: '2FA activado correctamente',
        status: 'success',
        isClosable: true,
      });
      setYaActivado(true);
    } catch (err) {
      toast({
        title: 'Código inválido',
        status: 'error',
        isClosable: true,
      });
    } finally {
      setActivando(false);
    }
  };

  if (yaActivado) {
    return (
      <Alert status="success" borderRadius="md">
        <AlertIcon />
        Autenticación 2FA ya está activada en tu cuenta.
      </Alert>
    );
  }

  if (!qrCode) {
    return (
      <Box textAlign="center" py={10}>
        <Spinner size="xl" color="blue.500" />
        <Text mt={4}>Generando código QR...</Text>
      </Box>
    );
  }

  return (
    <Box borderWidth="1px" borderRadius="md" p={4}>
      <VStack spacing={4}>
        <Heading fontSize="md" textAlign="center">
          Activar Autenticación 2FA
        </Heading>
        <Text fontSize="sm" color="gray.500" textAlign="center">
          Escanea este código QR con Google Authenticator.
        </Text>
        <Image src={qrCode} alt="QR Code 2FA" borderRadius="md" />
        <Input
          placeholder="Código de 6 dígitos"
          maxLength={6}
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
        <Button
          isLoading={activando}
          colorScheme="teal"
          width="100%"
          onClick={confirmarCodigo}
        >
          Confirmar y Activar 2FA
        </Button>
      </VStack>
    </Box>
  );
};

export default Activar2FA;
